import { Button } from '@gravity-ui/uikit';
import { useLazyDownloadMkfDomainMentionsReportQuery } from 'store/api';
import styles from './styles.module.scss';
import { useMkfDomenDataQuery } from 'store/api/private/charts-api/chart-api-data';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ChartOptions } from 'chart.js/auto';

export const MkfDomainMentionsReport = () => {
	const [trigger, { isFetching }] = useLazyDownloadMkfDomainMentionsReportQuery();

	const {
		data: mkfDomenData,
		isLoading,
		error,
	} = useMkfDomenDataQuery(null, {
		refetchOnMountOrArgChange: true,
		refetchOnFocus: true,
		refetchOnReconnect: true,
	});

	const chartData = {
		labels: mkfDomenData?.map((d) => (d.mkfDomain === '' ? 'Нет домена' : d.mkfDomain)),
		datasets: [
			{
				label: 'Количество упоминаний',
				data: mkfDomenData?.map((d) => d.totalPatients),
				backgroundColor: ['#7ca7aeff', '#e4a786ff', '#f0a6a7ff', '#7c595aff'],
				borderWidth: 1,
			},
		],
	};

	const options: ChartOptions<'pie'> = {
		responsive: true,
		plugins: {
			legend: { position: 'bottom' as const },
			datalabels: {
				color: '#fff',
				font: { weight: 'bold', size: 12 },
				anchor: 'center',
				align: 'center',
				clamp: true,
				formatter: (value: number, ctx: any) => {
					const label = ctx.chart.data.labels?.[ctx.dataIndex] ?? '';
					return ` ${value}`;
				},
			},
			// tooltip: { callbacks: { label: (ctx: any) => `${ctx.label}: ${ctx.parsed} чел.` } },
		},
	};

	const handleDownload = async () => {
		try {
			const result = await trigger().unwrap();
			const url = window.URL.createObjectURL(result);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Отчёт по МКФ-доменам.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Ошибка при скачивании файла:', error);
		}
	};
	return (
		<div className={styles.chart}>
			<h2>Данные по МКФ-доменам</h2>
			<div style={{ width: '100%', maxHeight: 700, display: 'flex', justifyContent: 'center' }}>
				<Pie data={chartData} options={options} plugins={[ChartDataLabels as any]} />
			</div>

			<Button onClick={handleDownload} loading={isFetching} size="xl">
				{isFetching ? 'Скачивание...' : 'Скачать отчёт по МКФ-доменам'}
			</Button>
		</div>
	);
};
